import { FC, MouseEventHandler } from 'react';
import classNames from 'classnames';
import { i18n as I18n } from 'utils/i18n';

interface Props {
  loading?: boolean;
  currentPage: number;
  perPage: number;
  total: number;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const Pager: FC<Props> = ({
  loading = false,
  currentPage,
  perPage,
  total,
  onClick,
  className: classNameProp,
}) => {
  const className = classNames('pager', classNameProp);

  const currentPageNum = () =>
    currentPage * perPage >= total ? total : currentPage * perPage;

  return (
    <div className={className} data-testid="pagerWrapper">
      {!loading && (
        <span className="pager__info">
          {I18n.t('pager.info', { current: currentPageNum(), total })}
        </span>
      )}

      {currentPage * perPage <= total && (
        <button
          onClick={onClick}
          disabled={loading}
          className="button button--primary button--medium load-more"
        >
          {loading ? I18n.t('pager.loading') : I18n.t('pager.load_more')}
        </button>
      )}
    </div>
  );
};

export default Pager;
